import { configureStore } from '@reduxjs/toolkit';
import podcastsReducer from './slices/podcastsSlice';
import themeReducer from './slices/themeSlice';
import analyze13Reducer from './slices/analyze13Slice';

export const store = configureStore({
  reducer: {
    podcasts: podcastsReducer,
    theme: themeReducer,
    analyze13: analyze13Reducer,
  },
}); 